import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Success from "@/pages/Success";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import { getToken } from "@/lib/api";

// Code-split: admin bundle (recharts, charts, dialogs) only loads when needed
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));

function ProtectedRoute({ children }) {
    return getToken() ? children : <Navigate to="/admin/login" replace />;
}

function AdminFallback() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-[#050505]">
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">loading...</div>
        </div>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/success" element={<Success />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                    <Route
                        path="/admin/login"
                        element={
                            <Suspense fallback={<AdminFallback />}>
                                <AdminLogin />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/admin/dashboard"
                        element={
                            <Suspense fallback={<AdminFallback />}>
                                <ProtectedRoute>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            </Suspense>
                        }
                    />
                    <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#111",
                        border: "1px solid rgba(255,255,255,0.1)",
                        color: "#fff",
                    },
                }}
            />
        </div>
    );
}

export default App;
